/**
 * URL base da API (ADR-016): `apiFetch` espera URL completa, não prefixa sozinho.
 *
 * O Vite resolve `VITE_API_URL` em BUILD-TIME (ARG/ENV do Dockerfile). Em
 * produção, cair no fallback `http://localhost:8000` apontaria o app inteiro
 * para o host errado silenciosamente — por isso, com `VITE_ENVIRONMENT=production`
 * e `VITE_API_URL` vazio, o build falha de forma explícita.
 */
const LOCAL_FALLBACK = 'http://localhost:8000'

export function resolveApiBase(
  apiUrl: string | undefined,
  environment: string | undefined,
): string {
  const url = (apiUrl ?? '').trim()
  if (url) return url

  if ((environment ?? '').trim().toLowerCase() === 'production') {
    throw new Error(
      'VITE_API_URL nao configurada em build de producao (VITE_ENVIRONMENT=production). ' +
        'Sem ela o app apontaria para http://localhost:8000. ' +
        'Passe o build-arg VITE_API_URL=https://granja.mmalabs.com.br no build da imagem.',
    )
  }

  return LOCAL_FALLBACK
}

export const API_BASE = resolveApiBase(
  import.meta.env.VITE_API_URL,
  import.meta.env.VITE_ENVIRONMENT,
)
